import React from 'react';
import { useHistory } from 'react-router-dom';
import connectUser from '../connectUser';
import Icon from '../ui/Icon';
import { gradientFor } from '../theme/tokens';
import { populatedCategories, appsByCategory } from '../registry/selectors';
import './screens.css';

// The "Categories" tab — browse by category (distinct from the search/store).
function CategoriesScreen({ userInfo }) {
  const history = useHistory();
  const routes = userInfo?.routes ? [...userInfo.routes] : [];
  const cats = populatedCategories(routes);

  return (
    <div className="hive-container hive-screen">
      <h1 className="hive-h2 hive-screen-h">Categories</h1>
      <div className="hive-cat-grid">
        {cats.map((c) => {
          const count = appsByCategory(c.id, routes).length;
          return (
            <button
              key={c.id}
              type="button"
              className="hive-cat-card hive-tap hive-focusable"
              onClick={() => history.push(`/store/category/${c.id}`)}
            >
              <span className="hive-cat-card-tile" style={{ background: gradientFor(c.id) }}>
                <Icon name={c.icon} size={26} color="#fff" strokeWidth={2.2} />
              </span>
              <span className="hive-cat-card-body">
                <span className="hive-cat-card-label">{c.label}</span>
                <span className="hive-cat-card-count">{count} {count === 1 ? 'app' : 'apps'}</span>
              </span>
              <Icon name="ChevronRight" size={18} className="hive-cat-card-chev" />
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default connectUser(CategoriesScreen);
